export default __webpack_public_path__ + "static/media/logo.54934fae.png";